import React from 'react'
import { StreamData } from 'types/streamData'
import { WidgetId } from 'features/types'
import { Soundbite } from './Soundbite'
import Deleted from './Deleted'
import { useWidgetSettingContext } from '../widgetSettingContext'

type SoundbiteStreamProps = {
  widgetId: WidgetId
  soundbites: StreamData[]
  deletedSentenceCount: number
  deletedSentenceDateRangeFrom: number
  deletedSentenceDateRangeTo: number
  batch: number
}

const SoundbiteStream = ({
  widgetId,
  soundbites,
  deletedSentenceCount,
  deletedSentenceDateRangeFrom,
  deletedSentenceDateRangeTo,
  batch
}: SoundbiteStreamProps) => {
  const { maxSoundbites } = useWidgetSettingContext()

  return (
    <>
      {soundbites.map((soundbite, index) => {
        const { documentId } = soundbite
        const key = `${documentId}-${index}`
        return (
          <Soundbite
            widgetId={widgetId}
            streamData={soundbite}
            key={key}
            serialNumber={batch * maxSoundbites + index}
          />
        )
      })}
      <Deleted
        deletedSentenceCount={deletedSentenceCount}
        deletedSentenceDateRangeFrom={deletedSentenceDateRangeFrom!}
        deletedSentenceDateRangeTo={deletedSentenceDateRangeTo!}
        serialNumber={batch * maxSoundbites + maxSoundbites - deletedSentenceCount}
      />
    </>
  )
}

export default SoundbiteStream
